<template>
    <div class="news-page">
      <div class="row">
        <h3>News</h3>
        <TradingViewTape :darkTheme="darkTheme" />
        <div class="settings">
          <div class="search">
            <input type="text" placeholder="Live Search" v-model="searchString">
          </div>
          <div class="refresh" @click="getNews" title="Refresh"></div>
          <div class="resize pointer" :class="{'active':largeView}" @click="largeView = !largeView" title="Resize"></div>
        </div>
      </div>
      <div class="news-block flex f-wrap" :class="{'large-view':largeView}" v-if="visibleNews.length">
        <div class="news-item" v-for="item in visibleNews" :key="item.title">
          <div class="img" v-if="item.thumbnail"  :style="{backgroundImage:`url(${item.thumbnail})`}"></div>
          <a :href="item.link" target="_blank">{{item.title}}</a>
          <div class="text" v-html="item.description"></div>
          <div class="meta">
            <div class="category">{{item.category}}</div>
            <div class="time">{{moment(item.pubDate).format('D MMM')}}</div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import TradingViewTape from '../common/TradingViewTape'
const API_KEY = 'ozodv9lwxlahhsjjfmbsx8dynnd9fjecuoytfltz';

function get_img_src_from_text(str) {
    var rex = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;
    var text = str.replaceAll("\"", '"').replaceAll(".jpg", ".jpg />").replaceAll(".png", ".png />").replaceAll(".bmp", ".bmp />").replaceAll(".webp", ".webp />")
    var res = rex.exec(text);
    if(res) {
      return res[1];
    }
    return ""
}

function NewsObject(title, thumbnail, link, description, category, date){
  this.title = title;
  this.thumbnail = thumbnail;
  this.link = link;
  this.description = description;
  this.category = category;
  this.date = date;
}

function getTextFromContent(content){
  return content.split(`</p>`)[1].replace('<p>','');
}

export default {
  name: 'News',
  props:['darkTheme'],
  components:{
    TradingViewTape
  },
  data: () => ({
    largeView:true,
    searchString:'',
    cointelegraphNews:[],
    bitcoinistNews:[],
    bitcoinNews:[]
  }),
  computed:{
    allNews(){
      let allNews = [];

      // get News from cointelegraphNews
      this.cointelegraphNews.forEach(item => {
        if (item.title && item.content && item.categories[0])
        allNews.push( new NewsObject(
          item.title,
          item?.enclosure?.link,
          item.link,
          getTextFromContent(item.content),
          item.categories[0],
          item.pubDate
          )
        );
      });

      // get News from bitcoinistNews
      this.bitcoinistNews.forEach(item => {
        if (item.title && item.link && item.description && item.categories[0])
        allNews.push( new NewsObject(
          item.title, 
          item?.enclosure?.link,
          item.link,
          item.description,
          item.categories[0],
          item.pubDate
          )
        );
      });

      // get News from bitcoinNews
      this.bitcoinNews.forEach(item => {
        if (item.title && item.link && item.content && item.categories[0])
        allNews.push( new NewsObject(
          item.title, 
          get_img_src_from_text(item.description),
          item.link,
          getTextFromContent(item.content),
          item.categories[0],
          item.pubDate
          )
        );
      });
      return allNews;
    },

    visibleNews(){
      let searchStr = this.searchString.toLowerCase().trim();
      let filterFunc = (item) => {
        return item.title.toLowerCase().includes(searchStr) ||
               item.description.toLowerCase().includes(searchStr) ||
               item.category.toLowerCase().includes(searchStr)
      }
      return this.allNews.filter(filterFunc);
    },
  },
  methods:{
    getNews(){
        axios.get('https://api.rss2json.com/v1/api.json?rss_url=https://cointelegraph.com/rss&api_key='+API_KEY+'&count=50').then(response => {
            if (response.status == 200)
            this.cointelegraphNews = response.data.items;
        });
        
        axios.get('https://api.rss2json.com/v1/api.json?rss_url=https://bitcoinist.com/feed&api_key='+API_KEY+'&count=50').then(response => {
            if (response.status == 200)
            this.bitcoinistNews = response.data.items;
        });

        axios.get('https://api.rss2json.com/v1/api.json?rss_url=https://news.bitcoin.com/feed&api_key='+API_KEY+'&count=50').then(response => {
            if (response.status == 200)
            this.bitcoinNews = response.data.items;
        });

    },
  },
  created(){
      this.getNews();
  }
};
</script>
<style lang="scss">
.news-page{
  .row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .settings{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 270px;
      @media (max-width: 650px) {
        margin-bottom: 15px;
      }
      .search{
        max-width: 180px;
      }
      .resize{
        mask: url('../../assets/img/resize.svg');
        mask-size: cover;
        background: var(--font-color);
        height: 28px;
        width: 28px;
        &.active{
          background: var(--live-amount-color);
        }
      }
    }
  }
  .news-block{
    margin: 0px -5px;
    .news-item{
      background: var(--input-bg-color);
      border: 1px solid var(--input-br-color);
      border-radius: 4px;
      padding: 13px 13px 40px;
      width: calc(20% - 10px);
      margin: 0 5px 10px;
      position: relative;
      &:hover{
        transform: scale(1.5);
        z-index: 150;
      }
      @media (max-width: 1200px) {
        width: calc(33.333% - 10px);
        &:hover{
          transform: none;
        }
      }
      @media (max-width: 800px) {
        width: calc(50% - 10px);
      }
      @media (max-width: 500px) {
        width: calc(100%);
      }
      .img{
        height: 75px;
        width: 75px;
        background-size: cover;
        background-position: center;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
      }
      & > a{
        color: var(--font-color);
        font-weight: bold;
        text-decoration: none;
        margin-top: 0px;
        font-size: 13px;
      }
      & > a,.text{
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .text{
        font-size: 12px;
        margin-top: 6px;
        color: var(--font-color);
        clear: both;
        h2{
          font-size: inherit;;
        }
      }
      .meta{
        display: flex;
        justify-content: space-between;
        width: calc(100% - 26px);
        position: absolute;
        bottom: 10px;
        font-size: 12px;
        font-weight: bold;
        .category,.time{
          color: var(--font-color);
        }
      }
    }
    &.large-view{
      .news-item{
        width: calc(33.333% - 10px);
        &:hover{
          transform: none;
        }
        @media (max-width: 900px) {
          width: calc(50% - 10px);
        }
        @media (max-width: 550px) {
          width: calc(100%);
        }
        .img{
          height: 160px;
          width: 100%;
          float: none;
          margin-right: 0;
          margin-bottom: 10px;
        }
        a{
          font-size: 19px;
        }
        .text{
          font-size: 15px;
          margin-top: 6px;
        }
        .meta{
          width: calc(100% - 26px);
          font-size: 15px;
        }
      }
    }
  }
}
</style>